import TtamInstantMessageAppList from './app-list/index.vue';
import TtamInstantMessageAppCheck from './app-check/index.vue';
import TtamInstantMessageAppMessengerId from './messenger-id/index.vue';
import TtamInstantMessageAppWhatsappId from './whatsapp-id/index.vue';

import * as hooks from './hooks';
export default {
  TtamInstantMessageAppList,
  TtamInstantMessageAppCheck,
  TtamInstantMessageAppMessengerId,
  TtamInstantMessageAppWhatsappId,
  ...hooks,
};
